import { render, staticRenderFns } from "./PendingEmployersTable.vue?vue&type=template&id=48e94a24&"
import script from "./PendingEmployersTable.vue?vue&type=script&lang=js&"
export * from "./PendingEmployersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports